import React, { useState } from 'react';
import '../App.css'; // Import CSS styles
import { Alert, Button } from 'react-bootstrap';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';



function SignupOtp() {

  const [userinput, setUserInput] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state?.email;
  const Name = location?.state?.Name;
  const username = location?.state?.username;
  const password = location?.state?.password;
  const college_id = location?.state?.college_id;
  const college_code = location?.state?.college_code;

  const [loading, setLoading] = useState(false);


  let authToken = `${process.env.REACT_APP_BASE_AUTHKEY}`;

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleOTP = () => {
    if (!email || !Name || !password) {
      navigate('/signup');
      return;
    }

    setLoading(true);
    console.log("data", Name, username, email);

    fetch('https://api.japaking.online/api/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: Name,
        userName: username,
        email: email,
        password: password,
        isActive: true,
        otp: otp,
        // college_id: college_id,
        college_code: college_code,
        role_id: 1,
      }),
    })
      .then(response => {
        if (!response.ok) {
          console.error('Response status:', response?.status);
          return response.json().then(errorData => {
            throw new Error(errorData?.message || 'An error occurred.');
          });
        }
        return response.json();
      })
      .then(data => {
        const { message } = data;
        console.log("this is my data", data);

        if (message?.token) {
          const token = message.token; // Extract token from the response
          localStorage.setItem('AuthToken', token); // Save token to localStorage
          console.log('Auth Token stored successfully:', token);

          navigate('/login'); // Navigate to the LanguageSelector page
        } else {
          alert("An error occurred. Please try again.");
        }
      })
      .catch(error => {
        console.error("Error creating account:", error);

        if (error.message === 'OTP mismatch') {
          alert("The OTP you entered is incorrect. Please try again."); // Specific alert for OTP mismatch
        } else {
          alert(error.message || "An error occurred. Please try again."); // General alert for other errors
        }

        setLoading(false);
      });
  };


  const handleLogin = async () => {
    try {
      // Call API to verify OTP
      const response = await axios.post(
        'https://api.japaking.online/otp/verify',
        { otp: userinput },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.data && response.data.success === true) {
        navigate("/Home", { state: { email: email } });

      } else {
        setErrorMessage('Invalid OTP. Please try again.');
      }
    } catch (error) {
      setErrorMessage('An error occurred while verifying OTP. Please try again.');
    }
  };

  const handleResendOTP = async () => {
    if (!email) {
      setErrorMessage("Missing signup email. Please sign up again.");
      return;
    }

    try {
      // Call API to resend OTP
      const response = await axios.post(
        'https://api.japaking.online/api/otp/send',
        { email: email } // Replace with actual user email if available
      );

      if (response.data.success) {
        setErrorMessage('OTP has been resent. Please check your email.');
      } else {
        setErrorMessage('Failed to resend OTP. Please try again.');
      }
    } catch (error) {
      setErrorMessage('An error occurred while resending OTP. Please try again.');
    }
  };

  return (
    <div className='userotp_Design_Main_Div_1'>
      <div className="container">
        <div className="row">
          <div className='col-md-12 col-sm-12 col-xs-12'>
            <div className='userotp_Design_Main_Div_2'>
              <div className='Div_1'>
                <h1>
                  <span onClick={handleGoBack}><ArrowBackIosIcon className='icon_size' /></span>
                  Email Verification
                </h1>
              </div>

              <div className="bottomView2">
                <h2 className='Email_veri_1'>Email Verification Code</h2>
                <p>{email}</p>
                <div>
                  <div className="inputView2">
                    <input
                      className="input"
                      placeholder="Enter OTP Code"
                      onChange={(e) => {
                        setUserInput(e.target.value);
                        setOtp(e.target.value); // Set the OTP value here
                      }}
                      value={userinput}
                    />

                  </div>

                  {errorMessage && (
                    <Alert variant="danger" className="mt-2">
                      {errorMessage}
                    </Alert>
                  )}
                  {loading ? (
                    <button
                      className="loginButton1"
                    >
                      Loading
                    </button>
                  ) : (
                    <button
                      className="loginButton1"
                      onClick={handleOTP}
                      disabled={!userinput}
                    >
                      Confirm
                    </button>
                  )}


                  <button
                    className="loginButton1"
                    onClick={handleResendOTP}
                  >
                    Resend OTP
                  </button>
                </div>

                <p className="signupText1">If you haven't received the OTP, please verify the email address you entered.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupOtp;
